import React,{Component} from 'react';
import { connect } from 'react-redux';
// utils
import {Translations, convertStringToArrayForRadio} from '../../../../utils';
//rest client
import {eapiClient, aemHostClient} from '../../../../restClient';
//children
import Radiobutton from '../../../common/Radio/radioButton';

class CanadaPersonalInformationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData:{},
      countryCanadaForm:{
        consentForm:[],
        signatories:[]
      },
      signatories:[],
      id:'',
      lid:'',
      methodFlag:false,
      dataReady: false,
      setCountryCanadaForm:{}
    };
  }

  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  componentWillMount() {
    var {caseId, productId} = this.props.match.params;
    let apiURL = "/aemData/formData/json_canada-personal-information-consent-form";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }

    aemHostClient(apiURL)
    .then(({data}) => {
      this.setState({ formJson :data});
    });

    var apiUrl;
    if(this.props.lang.currentLang.lang === 'English'){
      apiUrl =  "/countryForms/case/" + caseId + "/country/Canada?lang=en"
    }else if(this.props.lang.currentLang.lang === 'Spanish'){
      apiUrl =  "/countryForms/case/" + caseId + "/country/Canada?lang=es"
    }
    else if(this.props.lang.currentLang.lang === 'Bahasa'){
      apiUrl =  "/countryForms/case/" + caseId + "/country/Canada?lang=ba"
    }

    eapiClient(apiUrl)
    .then(({data}) => {
      this.setState({countryCanadaForm:{...this.state.countryCanadaForm, signatories : data.responseData}});
      eapiClient("/countryForms/case/" + caseId + "/product/" + productId )
      .then(({data}) => {
        this.setState({entityName:data.responseData.entityName})
        if(data.responseData.countryCanadaForm !== undefined){
            this.setState({ countryCanadaForm:{...this.state.countryCanadaForm,
            consentForm : data.responseData.countryCanadaForm.consentForm
          },
          id:data.responseData.id,
          lid:data.responseData.lid,
          methodFlag :true
        });

          let _consentForm = [];
          const {consentForm, signatories} = this.state.countryCanadaForm;
          consentForm.forEach(consentFormData => {
            _consentForm[signatories.findIndex(signatory => signatory.id === consentFormData.signatoryId)] = consentFormData;
          });
          this.setState({
            countryCanadaForm: {...this.state.countryCanadaForm, consentForm: _consentForm},
            dataReady: true
          });

        }else {
          this.setState({id:data.responseData.id, lid:data.responseData.lid,
            dataReady: true
          });
        }
      });
    });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }
  setAuthorised = (value, name) => {
    this.setState({personalInfoConsent: value});
  }

  setFormData =(index, signatoryId, id, event) => {
    let _consentForm = [...this.state.countryCanadaForm.consentForm];

    const personalInfoConsent = event.target.value;
    if(id === undefined ) {
      _consentForm[index] = {personalInfoConsent:personalInfoConsent, signatoryId};
    } else {
      let ids = id.id;
      _consentForm[index] = {personalInfoConsent:personalInfoConsent, signatoryId, id:ids};
    }

    this.setState({countryCanadaForm: {...this.state.countryCanadaForm, consentForm: _consentForm}});
  }

  renderFields(){

    let element=[];
    if(this.state.countryCanadaForm.signatories !==undefined){

      for(let i=0; this.state.countryCanadaForm.signatories.length > i; i++){
        element.push(<div className="gdocs-constent-wraper">
        <span className="gdocs-authorised-person">
        <b>{`${this.state.countryCanadaForm.signatories[i].firstName}
        ${this.state.countryCanadaForm.signatories[i].lastName}
        ${this.state.countryCanadaForm.signatories[i].dateOfBirth!==undefined ? ',':''}
        ${this.state.countryCanadaForm.signatories[i].dateOfBirth!==undefined ?
          this.state.countryCanadaForm.signatories[i].dateOfBirth :''}`}</b>
          </span>
          <span className="gdocs-authorised-radio-btn">
          <label className="gdocs-authorised-label">{this.translateWord(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_CAN2-i'].options)[0].split('=')[1]}
          <Radiobutton setInputvalue={this.setAuthorised}
          name={`authorisedPerson${i}`}

          _onChange={this.setFormData.bind(this, i, this.state.countryCanadaForm.signatories[i].id,
            this.state.countryCanadaForm.consentForm[i])}
            value="true"
            _value={this.state.countryCanadaForm.consentForm[i] !== undefined ?
              this.state.countryCanadaForm.consentForm[i].personalInfoConsent :''}
              />
              </label>

              <label className="gdocs-authorised-label">{this.translateWord(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_CAN2-i'].options)[1].split('=')[1]}
              <Radiobutton setInputvalue={this.setAuthorised}
              name={`authorisedPerson${i}`}
              _value = {this.state.countryCanadaForm.consentForm[i] !== undefined ?
                this.state.countryCanadaForm.consentForm[i].personalInfoConsent:''}
                _onChange={this.setFormData.bind(this, i, this.state.countryCanadaForm.signatories[i].id,
                  this.state.countryCanadaForm.consentForm[i])}
                  value="false"/>
                  </label>
                  </span>
                  </div>)
                }
              }
              return element;
            }
            saveForm =() =>{
              var payLoad={};
              var apiURL;
              var {caseId, productId} = this.props.match.params;
              payLoad.countryCanadaForm = this.state.countryCanadaForm;
              payLoad.caseId =caseId;
              payLoad.productId =productId;
              payLoad.id=this.state.id;
              payLoad.lid=this.state.lid;
              payLoad.countryFormName = "Canada personal information"
              apiURL ="/countryForms/case/" + caseId + "/product/" + productId;
              eapiClient(apiURL,{
                method:"PUT",
                data: JSON.stringify(payLoad)
              })
              .then(({data}) => {
              });
              this.props.history.goBack();
            }

            render() {
              let buttonJsx =(<h3>Loading.....</h3>);
              //const  {consentForm } = this.state.countryCanadaForm;
              // if(typeof consentForm != 'undefined' && consentForm.length > 0){
              if(this.state.formJson !== undefined){
                buttonJsx =(
                  <div>
                  <button onClick={this.saveForm} aria-label={this.state.formJson.guideContainer.rootPanel.items.guidebutton_saveAndReturn.text} className="gdocs-btn-submit"> {this.translations(this.state.formJson.guideContainer.rootPanel.items.guidebutton_saveAndReturn.text)}</button>
                  </div>
                );
              }
              const pageTitle = this.state.formJson ? this.state.formJson.guideContainer.rootPanel.items.static_text_mainTitle : {};
              return (this.state.dataReady ? (
                <div className="form-container">
                <div className="form-title">
                <h1 className="form-heading">{this.translations(pageTitle.name)}</h1>
                <div className="gdocs-clear-float"></div>
                <p className="pannel-sub-heading">{this.state.entityName}</p>
                <p className="form-required-desc optional-text">{this.translations(pageTitle.text)}</p>
                </div>
                <div className="gdocs-clear-float"></div>
                <div className="gdocs-content-min-ht">
                <p className="gdocs-canada-par-text">{this.translations(this.state.formJson.guideContainer.rootPanel.items.static_text_text1._value)}</p>
                <div className="gdocs-clear-float"></div>
                {this.renderFields()}
                </div>
                <div key="buttons-wrapper" className="form-buttons-section country-form-buttons-section">
                <div className="form-buttons-wrapper">
                {buttonJsx}
                </div>
                </div>
                </div>
              ) : '');
            }
          }

          const mapStateToProps = state => {
            return {
              lang:state.lang
            }
          }
          export default connect(mapStateToProps)(CanadaPersonalInformationForm);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CountryForms/CanadaPersonalInformationForm.js